import * as React from "react";
import { defaultValues } from "../../../services/defaults";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpInputNumber } from "../../gvc/testNewForm/CpInputNumber";

interface Props {
  index: number;
}
export const Syslog: React.FC<Props> = ({ index }) => {
  const df = defaultValues.org.logging.syslog;

  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.syslog.host`}>Host</CpLabel>
          <CpInput name={`logging.${index}.syslog.host`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`logging.${index}.syslog.host`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.syslog.port`}>Port</CpLabel>
          <CpInputNumber name={`logging.${index}.syslog.port`} />
          <CpErrorWarning name={`logging.${index}.syslog.port`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.syslog.mode`}>Mode</CpLabel>
          <CpSelect options={df.mode.selectOptions} name={`logging.${index}.syslog.mode`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`logging.${index}.syslog.mode`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.syslog.format`}>Format</CpLabel>
          <CpSelect
            options={df.format.selectOptions}
            name={`logging.${index}.syslog.format`}
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.syslog.format`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.syslog.severity`}>Severity</CpLabel>
          <CpSelect
            name={`logging.${index}.syslog.severity`}
            options={[
              {
                value: "0",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 0</div>
                    <div className="-mb-1 text-sm">Emergency (EMERG)</div>
                    <div className="font-semibold">System is unusable</div>
                  </div>
                ),
              },
              {
                value: "1",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 1</div>
                    <div className="-mb-1 text-sm">Alert (ALERT)</div>
                    <div className="font-semibold">Action must be taken immediately</div>
                  </div>
                ),
              },
              {
                value: "2",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 2</div>
                    <div className="-mb-1 text-sm">Critical (CRIT)</div>
                    <div className="font-semibold">Critical conditions</div>
                  </div>
                ),
              },
              {
                value: "3",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 3</div>
                    <div className="-mb-1 text-sm">Error (ERR)</div>
                    <div className="font-semibold">Error conditions</div>
                  </div>
                ),
              },
              {
                value: "4",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 4</div>
                    <div className="-mb-1 text-sm">Warning (WARNING)</div>
                    <div className="font-semibold">Warning Conditions</div>
                  </div>
                ),
              },
              {
                value: "5",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 5</div>
                    <div className="-mb-1 text-sm">Notice (NOTICE)</div>
                    <div className="font-semibold">Normal but significant conditions</div>
                  </div>
                ),
              },
              {
                value: "6",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 6</div>
                    <div className="-mb-1 text-sm">Informational (INFO)</div>
                    <div className="font-semibold">Informational messages</div>
                  </div>
                ),
              },
              {
                value: "7",
                label: (
                  <div className="py-2">
                    <div className="text-sm">Severity Level 7</div>
                    <div className="-mb-1 text-sm">Debug (DEBUG)</div>
                    <div className="font-semibold">Debug-level messages</div>
                  </div>
                ),
              },
            ]}
            style={{ height: 90, maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.syslog.severity`} />
        </CpFormItem>
      </div>
    </>
  );
};
